import React from 'react'
import LandingHeroCarousel from './LandingHeroCarousel/LandingHeroCarousel'
import LandingBenefits from './LandingBenefits/LandingBenefits'
import OnlineShoppingCategories from './OnlineShoppingCategories/OnlineShoppingCategories'
import SalarNowGroceries from './SalarNowGroceries/SalarNowGroceries'
import SalarFoodCategories from './SalarFoodCategories/SalarFoodCategories'
import LandingNavbar from '../../globalcomponents/LandingNavbar/LandingNavbar'

const EcommLandingPage = () => {
    return (
        <>
            <LandingNavbar />
            <LandingHeroCarousel />
            <LandingBenefits />
            <OnlineShoppingCategories />
            <SalarNowGroceries />
            <SalarFoodCategories />
        </>
    )
}

export default EcommLandingPage